import { useQuery } from 'data-fetching-client';
import { useCallback } from 'react';
import { GET_PRODUCTS_QUERY } from '../../../../__generated__/chirp/com/hubspot/buying/rpc/ProductRpc.dfc.new';
import { useIsPaidPortal } from '../../hooks/inventory/useProductInventory';
import { useIsInAppAuth } from '../../hooks/user/useUserInfo';
import { ALL_SIDE_NAV_PRODUCT_API_NAMES, HUBSPOT_CREDITS_PRODUCT_API_NAMES, MARKETING_PLUS_PRODUCT_API_NAMES } from '../constants/SideNavProductApiNames';
export const useSideNavVisibility = () => {
  var _productDetailsQuery$2;
  const {
    isPaidPortal,
    loading: isInventoryLoading
  } = useIsPaidPortal();
  const isInAppAuth = useIsInAppAuth();
  const productDetailsQuery = useQuery(GET_PRODUCTS_QUERY, {
    variables: {
      productApiNames: [...ALL_SIDE_NAV_PRODUCT_API_NAMES]
    }
  });
  const canViewProducts = useCallback(productApiNames => {
    var _productDetailsQuery$;
    const result = (_productDetailsQuery$ = productDetailsQuery.data) === null || _productDetailsQuery$ === void 0 ? void 0 : _productDetailsQuery$.result;
    const availableProductsToView = Object.keys((result === null || result === void 0 ? void 0 : result.productsByName) || {});
    return productApiNames.every(productApiName => availableProductsToView.includes(productApiName));
  }, [productDetailsQuery.data]);
  if (!((_productDetailsQuery$2 = productDetailsQuery.data) !== null && _productDetailsQuery$2 !== void 0 && _productDetailsQuery$2.result.productsByName)) {
    return {};
  }
  const canViewMarketingPlus = canViewProducts(MARKETING_PLUS_PRODUCT_API_NAMES);
  const canViewHubSpotCredits = canViewProducts(HUBSPOT_CREDITS_PRODUCT_API_NAMES);
  const canViewAddOns = isPaidPortal && !isInventoryLoading;
  const canViewFreeTools = !isPaidPortal && !isInventoryLoading;
  const canViewBundlesPage = !isInAppAuth;
  const canViewEnhancementsSection = canViewHubSpotCredits || canViewAddOns;
  return {
    canViewFreeTools,
    canViewMarketingPlus,
    canViewHubSpotCredits,
    canViewAddOns,
    canViewEnhancementsSection,
    canViewBundlesPage
  };
};